export default "__VITE_ASSET__BegmTEBU__"